import Binoculars16 from '@carbon/icons-react/es/binoculars/16';
import Close16 from '@carbon/icons-react/es/close/16';
import { Tooltip } from 'antd';
import { duration } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { humanise } from 'components/atoms/humanised-date';
import { AvailabilityFilter } from '../types';
import { removeInsignificantTrailingZero } from '../utils/dates';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
`;
const ValueWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  svg {
    margin-right: var(--spacing-02);
  }
`;

interface Props {
  availabilityFilter?: AvailabilityFilter;
  onClick: () => void;
  onReset: () => void;
  isHoursPerWeek: boolean;
}
export const AvailabilityFilterTrigger: FC<Props> = ({
  availabilityFilter,
  onClick,
  onReset,
  isHoursPerWeek,
}) => {
  return (
    <>
      {availabilityFilter == null ? (
        <Button
          icon={<Binoculars16 />}
          type="text"
          size="small"
          onClick={onClick}
        >
          <FormattedMessage id="resource_management.availability_criteria.trigger" />
        </Button>
      ) : (
        <>
          <Tooltip
            title={
              <FormattedMessage id="resource_management.availability_criteria.trigger" />
            }
          >
            <Button type="text" size="small" onClick={onClick}>
              <Wrapper>
                <ValueWrapper>
                  <Binoculars16 />
                  <FormattedMessage
                    id="resource_management.availability_criteria.trigger_with_value"
                    values={{
                      time: `${removeInsignificantTrailingZero(
                        duration(
                          availabilityFilter.availableMinutes,
                          'minutes',
                        ).asHours(),
                      )}h/${isHoursPerWeek ? 'w' : 'd'}`,
                      date: `${humanise(
                        availabilityFilter.startDate,
                      )} - ${humanise(availabilityFilter.endDate)}`,
                      strong: (chunks) => <strong>{chunks}</strong>,
                    }}
                  />
                </ValueWrapper>
              </Wrapper>
            </Button>
          </Tooltip>
          <Tooltip
            title={
              <FormattedMessage id="resource_management.availability_criteria.clear" />
            }
          >
            <Button
              type="text"
              size="small"
              icon={<Close16 />}
              onClick={onReset}
            />
          </Tooltip>
        </>
      )}
    </>
  );
};
